export default __webpack_public_path__ + "static/media/victor_artishuk.35af12f4.jpg";